import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function RegulatoryHorizonMethodology() {
  return (
    <CustomerMethodologyPage
      title="Regulatory horizon — overview"
      description="How WeConsult Rx tracks upcoming regulatory changes relevant to your operating jurisdictions and facility types."
      path="/trust/regulatory-horizon-methodology"
    >
      <p>
        The regulatory horizon dashboard surfaces upcoming rule changes,
        comment periods, and effective dates filtered to your tenant&apos;s
        declared jurisdictions and facility types.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Federal and state regulatory actions on a timeline.</li>
        <li>Filtering by your operating jurisdictions and facility types.</li>
        <li>Quarterly catalog refresh to capture new entries.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Consultant pharmacists and compliance officers get advance notice of
        changes that affect their facilities — without manual monitoring of
        multiple regulatory sources.
      </p>
    </CustomerMethodologyPage>
  );
}
